import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, checking } = useAuth();

  if (checking || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink">
        <div className="font-mono text-xs tracking-[0.3em] text-gold animate-pulse">CHARGEMENT…</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/connexion" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/espace-client"} replace />;
  }
  return children;
}
